import { useState } from 'react';

import Checkbox from '@preqin/ui-components/cjs/core/Forms/Checkbox/Checkbox.Form.js';
import Modal from '@preqin/ui-components/cjs/core/Modal';

import { ModalProps } from './ModalProps';

export const ReportFilterDeleteModal = ({ isOpen, isLoading, filters, handleCancel, handleSubmit }: ModalProps) => {
  const [selectedIds, setSelectedIds] = useState<Array<number>>([]);

  const handleCheckboxChange = (checked: boolean, id: number) => {
    if (checked) {
      setSelectedIds([...selectedIds, id]);
    } else {
      const idsToDelete = selectedIds.filter((selectedId) => selectedId !== id);
      setSelectedIds(idsToDelete);
    }
  };

  return (
    <Modal
      headerTitle="Manage saved search"
      isOpen={isOpen}
      size="md"
      primaryButtonDisabled={isLoading || selectedIds.length === 0}
      primaryButtonText={isLoading ? 'Deleting' : 'Delete search'}
      secondaryButtonText="Cancel"
      primaryButtonType="alert"
      primaryButtonLoading={isLoading}
      handleOnModalToggleFunction={handleCancel}
      handleOnModalPrimaryButtonClick={() => handleSubmit(selectedIds)}
      handleOnModalSecondaryButtonClick={handleCancel}
      bodyContent={
        <>
          {filters.map((filter) => (
            <div style={{ marginBottom: '16px' }} key={filter.id}>
              <Checkbox
                key={filter.id}
                id={filter.id}
                checked={selectedIds.includes(filter.id)}
                showLabel
                labelText={filter.name}
                handleOnCheck={(checked: boolean) => handleCheckboxChange(checked, filter.id)}
              />
            </div>
          ))}
        </>
      }
    />
  );
};
